import { Checkbox, HStack, Table, Text } from '@chakra-ui/react'
import { TrafficLightStatus } from './TrafficLightStatus'
import type { MatchingSib } from '../types'

interface MatchingSibTableProps {
  sibs: MatchingSib[]
  selectedSibIds: string[]
  onSelectionChange: (sibIds: string[]) => void
}

export function MatchingSibTable({
  sibs,
  selectedSibIds,
  onSelectionChange,
}: MatchingSibTableProps) {
  const allSelected = sibs.length > 0 && sibs.every(sib => selectedSibIds.includes(sib.id))

  function toggleSib(sibId: string) {
    if (selectedSibIds.includes(sibId)) {
      onSelectionChange(selectedSibIds.filter(id => id !== sibId))
      return
    }

    onSelectionChange([...selectedSibIds, sibId])
  }

  function toggleAll(checked: boolean) {
    if (checked) {
      onSelectionChange(sibs.map(sib => sib.id))
      return
    }

    onSelectionChange([])
  }

  return (
    <Table.Root>
      <Table.Header>
        <Table.Row>
          <Table.ColumnHeader width="60px">
            <Checkbox.Root
              checked={allSelected}
              onCheckedChange={details => toggleAll(Boolean(details.checked))}
            >
              <Checkbox.HiddenInput />
              <Checkbox.Control />
            </Checkbox.Root>
          </Table.ColumnHeader>

          <Table.ColumnHeader>SIB</Table.ColumnHeader>

          <Table.ColumnHeader>Location</Table.ColumnHeader>

          <Table.ColumnHeader>Capacity Match</Table.ColumnHeader>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {sibs.map(sib => (
          <Table.Row key={sib.id}>
            <Table.Cell>
              <Checkbox.Root
                checked={selectedSibIds.includes(sib.id)}
                onCheckedChange={() => toggleSib(sib.id)}
              >
                <Checkbox.HiddenInput />
                <Checkbox.Control />
              </Checkbox.Root>
            </Table.Cell>

            <Table.Cell>
              <Text fontWeight="medium">{sib.name}</Text>
            </Table.Cell>

            <Table.Cell>
              <HStack gap={1}>
                {sib.postalCode && <Text>{sib.postalCode}</Text>}
                {sib.city && <Text>{sib.city}</Text>}
              </HStack>
            </Table.Cell>

            <Table.Cell>
              <TrafficLightStatus status={sib.trafficLightStatus ?? 'red'} />
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  )
}
